import apiST from "../../services/service_shotstorage";
import apiItem from "../../services/service_item";
import apiMarim from "../../services/service_undefined_v2";
import Swal from "sweetalert2";
var moment = require("moment");

export default {
  data() {
    return {
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      bill_list: [],
      list_group: [],
      group_code: "",
      data_modal: {
        id: 0,
        company_id: 1,
        branch_id: 0,
        doc_no: "",
        doc_date: moment(new Date()),
        accept_date: "",
        description: "",
        accept_status: 0,
        is_confirm: 0,
        is_cancel: 0,
        subs: []
      },
      req_list: {
        group_code: "",
        branch_id: 0,
        is_hold: 0
      },
      bill_data: {
        company_id: 1,
        branch_id: 1,
        id: 0,
        doc_no: ""
      },
      branch: 0,
      modal_active: false,
      form_data: {}
    };
  },
  methods: {
    getListData() {
      if (this.req_list.branch_id === 0) {
        alert("กรุณาเลือกสาขา");
        return;
      }
      this.$store.commit("Loading");

      apiMarim.getStockEgg(
        {
          branch_id: this.req_list.branch_id,
          group_id: '50'
        },
        this.header,
        results => {
          if (results.data.status) {
            this.bill_list = results.data.data;
          }
          this.$store.commit("Loading");
        },
        errors => {
          this.$store.commit("Loading");
          // this.$store.commit("Loading");
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
        }
      );
      // apiST.reportStk(sessionStorage.Url,
      //   this.header,
      //   this.req_list,
      //   result => {
      //     if (result.response === 'success') {
      //       this.bill_list = result.data[0]
      //     } else {
      //     }
      //     this.$store.commit('Loading')
      //   },
      //   error => {
      //     this.$store.commit('Loading')
      //     alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
      //   }
      // )
    },
    resetStock() {


      

      if (this.req_list.branch_id === 0) {
        alert("กรุณาเลือกสาขา");
        return;
      }

      Swal.fire({
        title: 'ลบข้อมูลคงคลังไข่',
        text: 'ท่านต้องการลบข้อมูลคงคลังไข่ ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ปฏิเสธ',
        cancelButtonColor: 'red',
        reverseButtons: true
      }).then((result) => {
        if(result.isConfirmed) {
          this.$store.commit("Loading");
          apiMarim.resetStockEgg(
            {
              branch_id: this.req_list.branch_id,
              user_id: this.$store.state.user.username
            },
            this.header,
            results => {
              if (results.data.status) {
                Swal.fire({
                  icon: "success",
                  title: "ทำรายการสำเร็จ",
                  showConfirmButton: false,
                  timer: 4000
                }).then(() => {
                  this.getListData();
                });
              } else {
                this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", "");
              }
              this.$store.commit("Loading");
            },
            errors => {
              this.$store.commit("Loading");
              // this.$store.commit("Loading");
              this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
            }
          );
        }
      });
    },
    getGroupList() {
      apiItem.itemGroup(
        sessionStorage.Url,
        this.header,
        {},
        result => {
          if (result.response === "success") {
            this.list_group = result.data;
          }
        },
        error => {
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
        }
      );
    },
    InspectByID(val) {
      this.$store.commit("Loading");
      let body = {
        company_id: 1,
        branch_id: 1,
        id: parseInt(val)
      };
      apiST.getInspectByID(
        sessionStorage.Url,
        this.header,
        body,
        result => {
          if (result.response === "success") {
            this.data_modal = result.data;
            this.modal_active = true;
          } else {
          }
          this.$store.commit("Loading");
        },
        error => {
          this.$store.commit("Loading");
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
        }
      );
    },
    printPDF() {
      this.form_data = JSON.stringify(this.bill_list);
      console.log(this.bill_list);
      setTimeout(() => {
        this.$refs.printPDF.submit();
      }, 1000);
    },
    printEXCEL() {
      this.form_data = JSON.stringify(this.bill_list);
      console.log(this.form_data);
      setTimeout(() => {
        this.$refs.printEXCEL.submit();
      }, 1000);
    }
  },
  mounted() {
    this.getBranch();
    this.getGroupList();
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/report_stk_egg.js